/* Glowie fixes
   1) Appstle: husk kundens valg (Engangskøb / Abonnement).
      Appstle fjerner og genopbygger boksen efter "Læg i kurv" og vælger så abonnement igen.
      Vi husker kundens eget valg og sætter det tilbage, så snart boksen er tilbage
      (før den nås at blive vist), og vi holder pladsen, så siden ikke hopper imens.
   2) Kurv: skjul "Forudbestilling: ..." på kurvlinjer.
   3) Prisen i toppen følger valget: abonnementspris ved Abonnement, normal pris ved Engangskøb. */
(function () {
  if (window.__glowieFixes) return;
  window.__glowieFixes = true;

  /* ---------- 1) Appstle: behold valget ---------- */
  var chosen = null;        // { value: '' (engangskøb) | plan-id, plan: værdi i dropdown }
  var lastTouch = 0;        // seneste gang kunden selv rørte boksen
  var HOLD_MS = 8000;       // så længe vi holder pladsen efter "Læg i kurv"
  var held = [];

  function widgetOf(el) {
    return el && el.closest ? el.closest('.appstle_sub_widget') : null;
  }

  function readWidget(w) {
    var checked = w.querySelector('input[type="radio"][name="selling_plan"]:checked');
    if (!checked) return null;
    var select = w.querySelector('select.appstle_select');
    return { value: checked.value, plan: select ? select.value : null };
  }

  // Hvad vil kunden? Afgøres ud fra, HVOR der klikkes – ikke ud fra radioknappens tilstand,
  // som Appstle kan nå at ændre lidt senere.
  function subRadio(w) {
    return w.querySelector('.appstle_subscription_radio_wrapper input[type="radio"][name="selling_plan"]') ||
      w.querySelector('input[type="radio"][name="selling_plan"]:not([value=""])');
  }
  function intentOf(t, w) {
    if (!t || !t.closest) return null;
    if (t.closest('.appstle_one_time_details_wrapper')) return '';
    if (t.closest('.appstle_subscription_radio_wrapper, .appstle_include_dropdown') || (t.matches && t.matches('select.appstle_select'))) {
      var r = subRadio(w);
      return r && r.value ? r.value : 'sub';
    }
    return null;
  }
  function remember(e) {
    var w = widgetOf(e.target);
    if (!w || !e.isTrusted) return;
    if (e.type === 'change' && Date.now() - lastTouch > 3000) return; // ikke kundens eget valg
    var v = intentOf(e.target, w);
    if (v === null) return;
    var select = w.querySelector('select.appstle_select');
    chosen = { value: v, plan: v !== '' && select ? select.value : null };
    // Planen (2 / 4 mdr.) læses igen lidt efter, når dropdown'en har fået sin nye værdi
    if (v !== '') setTimeout(function () { if (chosen && chosen.value !== '' && select && select.isConnected) chosen.plan = select.value; }, 100);
  }

  // Kundens egne klik/taster i boksen
  function touch(e) {
    if (e.isTrusted && widgetOf(e.target)) lastTouch = Date.now();
  }
  document.addEventListener('pointerdown', touch, true);
  document.addEventListener('keydown', touch, true);
  document.addEventListener('click', remember, true);
  document.addEventListener('change', remember, true);

  function apply(w) {
    if (!chosen || Date.now() - lastTouch < 800) return;
    var now = readWidget(w);
    if (!now) return;
    var wantSub = chosen.value !== '';
    if ((now.value !== '') !== wantSub) {
      var target = wantSub ? subRadio(w) : w.querySelector('input[type="radio"][name="selling_plan"][value=""]');
      if (target && !target.checked) target.click();
    }
    if (wantSub && chosen.plan) {
      var select = w.querySelector('select.appstle_select');
      if (select && select.value !== chosen.plan && select.querySelector('option[value="' + chosen.plan + '"]')) {
        select.value = chosen.plan;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function applyAll() {
    document.querySelectorAll('.appstle_sub_widget').forEach(apply);
  }

  // Hold pladsen, mens Appstle genopbygger boksen efter "Læg i kurv"
  function releaseHolds() {
    held.forEach(function (b) { clearTimeout(b.__glHoldTimer); b.style.minHeight = ''; b.__glHoldWidget = null; });
    held = [];
  }
  function holdHeights() {
    releaseHolds();
    document.querySelectorAll('.appstle_sub_widget').forEach(function (w) {
      var b = w.parentElement;
      if (!b || !b.offsetHeight) return;
      b.style.minHeight = b.offsetHeight + 'px';
      b.__glHoldWidget = w;
      b.__glHoldTimer = setTimeout(function () { b.style.minHeight = ''; }, HOLD_MS);
      held.push(b);
    });
  }
  var holdCheckTimer = null;
  function checkHolds() {
    if (!held.length) return;
    var waiting = false;
    held = held.filter(function (b) {
      var w = b.querySelector('.appstle_sub_widget');
      if (!w || w === b.__glHoldWidget) return true;
      if (w.classList.contains('appstle-hidden') || !w.offsetHeight) { waiting = true; return true; }
      // Ny boks er synlig (og valget sat tilbage) -> slip pladsen.
      // Boksen tones blidt frem, så Appstles egen radio-animation (fra abonnement) ikke ses.
      clearTimeout(b.__glHoldTimer);
      b.style.minHeight = '';
      w.style.transition = 'none';
      w.style.opacity = '0';
      setTimeout(function () {
        w.style.transition = 'opacity .2s ease';
        w.style.opacity = '';
        setTimeout(function () { w.style.transition = ''; }, 250);
      }, 300);
      return false;
    });
    // Appstle viser boksen ved at fjerne en klasse – det fanger observeren ikke, så vi tjekker igen
    clearTimeout(holdCheckTimer);
    if (waiting) holdCheckTimer = setTimeout(checkHolds, 100);
  }

  function isAddForm(f) {
    return f && f.action && String(f.action).indexOf('/cart/add') !== -1;
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[name="add"], .add-to-cart-button, [type="submit"]');
    if (b && isAddForm(b.form)) holdHeights();
  }, true);
  // Skifter kunden størrelse, skal pladsen ikke holdes (2 ML har ingen abonnementsboks),
  // og prisen i toppen skal tilbage til størrelsens egen pris, indtil abonnementsboksen er klar igen
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('variant-picker')) return;
    releaseHolds();
    var sec = e.target.closest('.shopify-section');
    if (sec) sec.classList.remove('gl-sub-on');
  }, true);

  /* ---------- 3) Pris i toppen følger Engangskøb / Abonnement ---------- */
  var subStyle = document.createElement('style');
  subStyle.textContent =
    '.gl-sub-on product-price [ref="priceContainer"], .gl-sub-on .sticky-add-to-cart__price [ref="priceContainer"] { display: none !important; }' +
    '.gl-sub-on .gl-duo-pricetag { display: none !important; }' +
    '.gl-sub-pricetag { display: none; }' +
    '.gl-sub-on .gl-sub-pricetag { display: block; }';
  document.head.appendChild(subStyle);

  function syncSubPrice() {
    // Ingen abonnementsboks (fx 2 ML) -> vis størrelsens egen pris.
    // Undtagelse: lige efter "Læg i kurv", hvor Appstle kort fjerner boksen.
    if (!held.length) {
      document.querySelectorAll('.shopify-section.gl-sub-on').forEach(function (sec) {
        if (!sec.querySelector('.appstle_sub_widget')) sec.classList.remove('gl-sub-on');
      });
    }
    document.querySelectorAll('.appstle_sub_widget').forEach(function (w) {
      var scope = w.closest('.shopify-section');
      if (!scope) return;
      var checked = w.querySelector('input[type="radio"][name="selling_plan"]:checked');
      var amount = w.querySelector('.appstle_subscription_radio_wrapper .appstle_subscription_amount');
      var text = amount ? amount.textContent.trim() : '';
      var on = !!(checked && checked.value && text);
      if (scope.classList.contains('gl-sub-on') !== on) scope.classList.toggle('gl-sub-on', on);
      if (!on) return;
      scope.querySelectorAll('product-price [ref="priceContainer"], .sticky-add-to-cart__price [ref="priceContainer"]').forEach(function (pc) {
        var parent = pc.parentNode;
        var tag = parent.querySelector(':scope > .gl-sub-pricetag');
        if (!tag) {
          tag = document.createElement('div');
          tag.className = 'gl-sub-pricetag';
          tag.innerHTML = '<span class="price"></span>';
          var after = pc.nextElementSibling && pc.nextElementSibling.classList.contains('gl-duo-pricetag') ? pc.nextElementSibling : pc;
          parent.insertBefore(tag, after.nextSibling);
        }
        var span = tag.querySelector('.price');
        if (span.textContent !== text) span.textContent = text;
      });
    });
  }
  // Fanger også skift i dropdown (2 / 4 mdr.), hvis Appstle kun ændrer teksten
  document.addEventListener('change', function (e) {
    if (widgetOf(e.target)) { setTimeout(syncSubPrice, 30); setTimeout(syncSubPrice, 300); }
  }, true);
  document.addEventListener('click', function (e) {
    if (widgetOf(e.target)) { setTimeout(syncSubPrice, 30); setTimeout(syncSubPrice, 300); }
  }, true);

  /* ---------- 2) Skjul "Forudbestilling" i kurven ---------- */
  var PREORDER = /^\s*Forudbestilling/i;

  function hidePreorder() {
    document.querySelectorAll('.cart-items__property').forEach(function (p) {
      var dt = p.querySelector('dt');
      if (dt && PREORDER.test(dt.textContent) && p.style.display !== 'none') p.style.display = 'none';
    });
    document.querySelectorAll('.cart-items__properties').forEach(function (dl) {
      var visible = Array.prototype.some.call(dl.querySelectorAll('.cart-items__property'), function (p) {
        return p.style.display !== 'none';
      });
      var want = visible ? '' : 'none';
      if (dl.style.display !== want) dl.style.display = want;
    });
    document.querySelectorAll('.cart-items__variants-wrapper > p').forEach(function (p) {
      if (PREORDER.test(p.textContent) && p.style.display !== 'none') p.style.display = 'none';
    });
  }

  /* ---------- Fælles observer ---------- */
  var followUp = null;
  new MutationObserver(function () {
    hidePreorder();
    if (chosen) {
      // Sæt valget tilbage med det samme (før skærmen tegnes) og tjek igen lidt efter
      applyAll();
      clearTimeout(followUp);
      followUp = setTimeout(function () { applyAll(); setTimeout(applyAll, 400); }, 120);
    }
    syncSubPrice();
    checkHolds();
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hidePreorder(); syncSubPrice(); });
  } else {
    hidePreorder();
    syncSubPrice();
  }
})();
